import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DecomModel } from '../../../../../types';
import { pagesConfig } from '../../../../shared/pages-config';

export function useDecomPolicyActions() {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  const openDrawer = useCallback(
    (policy: DecomModel) => {
      setSearchParams((prev) => {
        prev.set('selectedDecomPolicy', policy.id);
        return prev;
      });
    },
    [setSearchParams]
  );

  const closeDrawer = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete('selectedDecomPolicy');
      return prev;
    });
  }, [setSearchParams]);

  const handleEditPolicy = useCallback(
    (policy: DecomModel) => {
      navigate({
        pathname: `/${
          pagesConfig.decommissioningLayout.link
        }/${pagesConfig.editDecomPolicyFormPage.link.replace(
          ':id',
          policy.id
        )}`,
      });
    },
    [navigate]
  );

  const handleClonePolicy = useCallback(
    (policy: DecomModel) => {
      navigate({
        pathname: `/${
          pagesConfig.decommissioningLayout.link
        }/${pagesConfig.cloneDecomPolicyFormPage.link.replace(
          ':id',
          policy.id
        )}`,
      });
    },
    [navigate]
  );

  return {
    openDrawer,
    closeDrawer,
    handleEditPolicy,
    handleClonePolicy,
  };
}
